import { useTranslation } from "react-i18next";
import { useState } from "react";
import TableEditModal from "./TableEditModal";
import { Table } from "@/types/globalTypes";
import TableNotAssignedTooltip from "./TableNotAssignedTooltip";
import axios from "axios";
import { useSelector } from "react-redux";
import TableAssignedTooltip from "./TableAssignedTooltip";
import useLockBodyScroll from "@/hooks/useLockBodyScroll";
import { useNavigate } from "react-router-dom";


import CurrentOrderToolTip from "./CurrentOrderToolTip";
import { LiaChairSolid } from "react-icons/lia";
import ElapsedTimer from "./ElapsedTimer";

type TableCardProps = {
  table: Table;
  floorNumber: number | string;
  floorId: number | string;
  setNeedRefetch: React.Dispatch<React.SetStateAction<boolean>>;
};

function TableCard({ table, floorNumber, setNeedRefetch, floorId }: TableCardProps) {
  const { t, i18n } = useTranslation();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [occupied, setoccupied] = useState(table.occupied);
  const lang = i18n.language;
  const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
  const baseUrl = import.meta.env.VITE_BASE_URL
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  useLockBodyScroll(isEditModalOpen);




  const handleToggle = async () => {
    if (loading) return;
    setLoading(true);

    const newStatus = !occupied;
    setoccupied(newStatus);

    try {
      await axios.put(
        `${baseUrl}/api/dashboard/floors/${table.floorId}/tables/${table._id}?locale=${lang}`,
        { occupied: newStatus },
        {
          headers: {
            Authorization: token,
          },
        }
      );
      setNeedRefetch(true);
    } catch (error) {
      setoccupied(!newStatus);
      console.error("Failed to update status", error);
    } finally {
      setLoading(false);
    }
  };
  function goToTableOrders() {
    if (table.currentGroupId) {

      navigate(`/tables/${floorId}/${table._id}`);
    }
  }
  return (
    <>
      <div
        onClick={goToTableOrders}
        className={`flex relative  xs:w-[170px] ${table.currentGroupId ? "cursor-pointer border-2 border-black bg-yellow-50" : occupied ? "border-2 border-border text-sidebar bg-red-200 " : "border-2 border-border text-sidebar bg-skyblue "} flex-col items-center justify-start gap-[48px] rounded-lg   py-[3px] pb-2 relative`}>
        {/* Toggle for Free/Occupied */}
        <div className="flex w-full flex-col gap-2">
          <div className="flex w-full items-center justify-between px-2">
            <div className="flex items-center">
              <LiaChairSolid size={30} />
              <span>{table.chairsCount}</span>
            </div>
            <div className="flex items-center  gap-1 mt-1">
              <div
                onClick={e => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleToggle();
                }}
                className={`w-12 h-6 flex items-center rounded-full p-1 cursor-pointer transition-colors duration-300 ${table.currentGroupId ? "bg-yellow-400" : occupied ? "bg-red-400" : "bg-green-500"
                  }`}
              >
                <div
                  className={`bg-white w-4 h-4 rounded-full shadow-md transform transition-transform duration-300 ${occupied
                    ? i18n.language === "ar"
                      ? "translate-x-0"
                      : "translate-x-6"
                    : i18n.language === "ar"
                      ? "-translate-x-6"
                      : "-translate-x-0"
                    }`}
                ></div>
              </div>
              <span className="text-xs font-medium">
                {occupied ? t("tableCard.statusOccupied") : t("tableCard.statusFree")}
              </span>
            </div>
          </div>
          <div className="flex items-center justify-between w-full px-2">
            {table.linkedWithQRCode ? <TableAssignedTooltip /> : <TableNotAssignedTooltip />}
            {table.occupied && table.occupiedAt && <ElapsedTimer fromTimestamp={table.occupiedAt} />}
            {table.currentGroupId && <CurrentOrderToolTip />}
          </div>
        </div>


        {/* <div className="relative">
          <img
            width={"140px"}
            height={"140px"}
            src="/images/placeholders/tableImage.svg"
            className="mb-2 aspect-square"
            style={{
              filter: table.currentGroupId
                ? 'invert(73%) sepia(83%) saturate(1047%) hue-rotate(1deg) brightness(130%) contrast(90%)'
                : 'none',
            }}


          />





          <span className={`absolute left-1/2 top-1/2  translate-x-[calc(-50%+1px)] translate-y-[calc(-50%-4.5px)] rounded-lg  px-2 py-1 text-center text-base font-bold  ${table.currentGroupId ? "bg-yellow-300 text-yellow-800" : "text-skyblue bg-sidebar"} min-w-[90px] max-w-[100px]`}>
            {t("tableCard.chairsCount", { count: table.chairsCount })}
          </span>
        </div> */}

        <p className={` text-center  text-3xl font-bold flex-1`}>
          {table.number}
        </p>


        <button onClick={(e) => {
          e.stopPropagation()
          setIsEditModalOpen(true)
        }} className="mt-1">
          {t("tableCard.edit")}
        </button>




      </div>

      {isEditModalOpen && (
        <TableEditModal
          table={table}
          floorNumber={floorNumber}
          setIsEditModalOpen={setIsEditModalOpen}
          setNeedRefetch={setNeedRefetch}
        />
      )}
    </>
  );
}

export default TableCard;
